// extracted by css-extract-rspack-plugin
export default {"block_wrapper":"hpcXoIZlraUnvL9m","btn":"gG4G3TFA0RAPQjFx"};